import CanView from "components/Common/CanView"
import HandleError from "components/Common/HandleError"
import React from "react"
import CreateTemplateModal from "./components/CreateTemplateModal"
import useDisclosure from "hooks/useDisclosure"
import useParamsQuery from "hooks/useParamsQuery"
import { useQuery } from "@tanstack/react-query"
import { Button, Card, CardBody } from "reactstrap"
import { t } from "i18next"
import useInitialData from "hooks/useInitialData"
import TemplateItem from "./components/TemplateItem"
import Paginate from "components/Common/Paginate"
import { getFolderTemplates } from "api/folderTemplateApi"

function FolderTemplatePage() {
  const { isOpen, toggle } = useDisclosure()
  const { params, addParam } = useParamsQuery()

  const { data, isLoading, error } = useQuery({
    queryKey: ["folder_templates", params],
    queryFn: () => getFolderTemplates(params),
  })
  const { results, count } = useInitialData(data)

  return (
    <React.Fragment>
      <CreateTemplateModal isOpen={isOpen} toggle={toggle} />
      <Card>
        <CardBody>
          <div className="space-between mb-3">
            <h4 className="h4">{t("folder templates")}</h4>
            <Button color="primary" onClick={toggle}>
              {t("create template")}
            </Button>
          </div>
          <HandleError
            isLoading={isLoading}
            error={error}
            isEmpty={!results.length}
          >
            <div className="vstack gap-2">
              {results.map(template => {
                return (
                  <TemplateItem key={template.id} templateData={template} />
                )
              })}
            </div>
          </HandleError>
          <div className="mt-3 box-center">
            <Paginate
              count={count}
              size={params.size || 10}
              forcePage={+params.page || 1}
              onPageChange={page => addParam({ page: page.selected + 1 })}
            />
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default FolderTemplatePage
